import { useMsal } from "@azure/msal-react"
import { InteractionStatus } from "@azure/msal-browser"

export const useMsalStatus = (): InteractionStatus => useMsal().inProgress
